/**
 * Admin Auth Context Definition
 *
 * Separated from provider for React Fast Refresh compatibility.
 */

import { createContext, type RefObject } from 'react';
import type { AdminUser } from '../types/admin';

export interface AdminAuthContextType {
  user: AdminUser | null;
  loading: boolean;
  sessionExpiresAt: string | null;
  /** The server's clock minus the browser's, measured at the last session check (0 when unknown). */
  serverClockOffsetMs: number;
  logout: () => Promise<void>;
  isAuthenticated: boolean;
  /** Synchronous auth snapshot for router guards — avoids stale React state between setUser() and commit. */
  isAuthenticatedRef: RefObject<boolean>;
  /** Synchronous user snapshot for router guards — same rationale as isAuthenticatedRef. */
  userRef: RefObject<AdminUser | null>;
  refreshSession: () => Promise<void>;
  /** Resolves with isAuthenticated when the initial session check completes (loading → false). */
  ready: Promise<boolean>;
}

export const AdminAuthContext = createContext<AdminAuthContextType | undefined>(undefined);
